import z from 'zod';

export const SignInSchema = z.object({
  email: z.string().email(),
  password: z
    .string()
    .min(6, { message: 'Password must contain at least 6 character(s)' }),
});

export const SignUpSchema = z.object({
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  username: z.string().min(2),
  email: z.string().email(),
  password: z
    .string()
    .min(6, { message: 'Password must contain at least 6 character(s)' }),
});

export const ForgotPasswordSchema = z.object({
  email: z.string().email(),
});

export const ResetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(6, { message: 'Password must contain at least 6 character(s)' }),
    passwordConfirmation: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.passwordConfirmation) {
      ctx.addIssue({
        code: 'custom',
        message: 'The passwords did not match',
        path: ['passwordConfirmation'],
      });
    }
    return true;
  });

export type SignInFields = z.infer<typeof SignInSchema>;
export type SignUpFields = z.infer<typeof SignUpSchema>;
export type ForgotPasswordFields = z.infer<typeof ForgotPasswordSchema>;
export type ResetPasswordFields = z.infer<typeof ResetPasswordSchema>;

export interface AuthResponse {
  access_token: string;
  user: User;
}

export interface AvailabilityCheckResponse {
  available: boolean;
}

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  SELLER = 'seller',
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  role: UserRole;
  createdAt: string;
}
